import { ForeignCurrencySettings } from '@/features/foreign_currency_settings';

const ForeignCurrencySettingsPage = () => {
  return <ForeignCurrencySettings />;
};
export default ForeignCurrencySettingsPage;
